<template>
  <div class="content">
    <div class="page-inner">
      <div>
        <ul class="nav justify-content-center">
          <li class="nav-item">
            <router-link :class="{ 'text-primary fw-bold': tab === 'all', 'text-muted': tab !== 'all' }" class="nav-link" aria-current="page" to="/feed">
              <i class="fa fa-chevron-right text-small" v-if="tab === 'all'"></i>
              {{ $t('new_releases') }}
            </router-link>
          </li>
          <li class="nav-item">
            <router-link :class="{ 'text-primary fw-bold': tab === 'mine', 'text-muted': tab !== 'mine' }" class="nav-link" :to="`/feed?user=${user._id}`">
              <i class="fa fa-chevron-right text-small" v-if="tab === 'mine'"></i>
              {{ $t('received_comments') }}
            </router-link>
          </li>
        </ul>
        <hr>
      </div>
      <div class="text-right">
        <span class="badge bg-warning mb-2" @click="showCreditsInfo()">
          {{ user.credits || 0 }} {{ $t('credits') }} <i class="fa fa-coins text-white ml-1"></i>
        </span><br />
        <button type="button" class="btn btn-sm btn-primary" @click="featureModal()">
          {{ $t('feature_release') }}
        </button>
      </div>
      <h1 class="mt-3" v-show="featuredReleases.length && tab !== 'mine'">
        {{ $t('featured_releases') }}
      </h1>
      <div class="mt-3" v-show="featuredReleases.length && tab !== 'mine'">
        <div class="carousel-slider-featured-releases owl-carousel">
          <div class="card card-dark bg-secondary-gradient" v-for="(release, releaseIndex) in featuredReleases" v-bind:key="`featured_${releaseIndex}`">
            <div class="card-body pos-relative">
              <i class="fa fa-star fa-2x featured-star text-warning"></i>
              <div class="row">
                <div class="col-md-1">
                  <a :href="`https://indfy.me/${release.key}`" target="_blank">
                    <img class="card-img-top rounded mb-3" :src="release.cover_image_small || release.cover_image"
                      alt="Product 1" onerror="this.src = '/static/img/img-placeholder.jpg'">
                  </a>
                </div>
                <div class="col-md-11">
                  <div>
                    <img width="16" :src="`/static/img/countries/${release.user.country || 'default'}.png`"
                      class="mr-1 mb-2" :alt="getCountryName(release.user.country)"
                      :title="getCountryName(release.user.country)" />
                    <a :href="`https://indfy.me/${release.key}`" target="_blank" class="h3 mb-2 fw-bold">
                      {{ release.title }}
                    </a>
                    <div class="small mb-1 pb-1">
                      <b>{{ $t('artist') }}:</b> {{ release.artist.name }}
                    </div>
                    <div class="small mb-1 pb-1">
                      <b>{{ $t('release_date') }}:</b> {{ moment(release.release_date).format('MMMM DD, YYYY') }}
                    </div>
                    <div class="small mb-1 pb-1">
                      <b>{{ $t('main_genre') }}:</b> {{ release.main_genre }} <i
                        class="fa fa-chevron-right text-white small ml-1 mr-1"></i> {{ release.style }}
                    </div>
                    <div class="small mb-1 pb-1">
                      <b>{{ $t('platforms') }}:</b>
                      <div class="mt-1">
                        <a :href="release.spotify_url" class="mb-1 btn-sm btn btn-light btn-border mt-1 mr-2 text-dark"
                          v-if="release.spotify_url" target="_blank">
                          <i class="fab fa-spotify mr-1"></i> Spotify
                        </a>
                        <a :href="release.youtube_url" class="mb-1 btn-sm btn btn-light btn-border mt-1 mr-2 text-dark"
                          v-if="release.youtube_url" target="_blank">
                          <i class="fab fa-youtube mr-1"></i> YouTube
                        </a>
                        <a :href="release.apple_url" class="mb-1 btn-sm btn btn-light btn-border mt-1 mr-2 text-dark"
                          v-if="release.apple_url" target="_blank">
                          <i class="fab fa-apple mr-1"></i> Apple Music
                        </a>
                        <a :href="release.deezer_url" class="mb-1 btn-sm btn btn-light btn-border mt-1 mr-2 text-dark"
                          v-if="release.deezer_url" target="_blank">
                          <i class="fa fa-link mr-1"></i> Deezer
                        </a>
                        <a :href="release.pandora_url" class="mb-1 btn-sm btn btn-light btn-border mt-1 mr-2 text-dark"
                          v-if="release.pandora_url" target="_blank">
                          <i class="fa fa-link mr-1"></i> Pandora
                        </a>
                        <a :href="release.amazon_url" class="mb-1 btn-sm btn btn-light btn-border mt-1 mr-2 text-dark"
                          v-if="release.amazon_url" target="_blank">
                          <i class="fa fa-link mr-1"></i> Amazon
                        </a>
                        <a :href="release.itunes_url" class="mb-1 btn-sm btn btn-light btn-border mt-1 mr-2 text-dark"
                          v-if="release.itunes_url" target="_blank">
                          <i class="fa fa-link mr-1"></i> iTunes
                        </a>
                      </div>
                    </div>
                  </div>

                  <div class="text-right" v-if="!hasCommented(release) && release.user._id !== user._id">
                    <button type="button" :class="{ 'btn-default': !hasCommented(release) }" class="btn"
                      @click="showCommentModal(release)">
                      {{ $t('add_comment') }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <h1 class="mt-3" v-if="tab === 'all'">
        {{ $t('latest_releases') }}
      </h1>
      <h1 class="mt-3" v-if="tab === 'mine'">
        {{ $t('received_comments') }}
      </h1>
      <p v-if="tab === 'mine'">
        {{ $t('showing_only_comments') }}
      </p>
      <div class="mt-3">
        <div class="card" v-for="(release, releaseIndex) in releases" v-bind:key="`release_${releaseIndex}`"
          v-show="(tab === 'all' && release.user._id !== user._id) || (tab === 'mine' && release.comments.length)">
          <div class="card-body">
            <div class="row">
              <div class="col-md-1" v-if="!release.spotify_id">
                <a :href="`https://indfy.me/${release.key}`" target="_blank">
                  <img class="card-img-top rounded mb-3" :src="release.cover_image_small || release.cover_image"
                    alt="Product 1" onerror="this.src = '/static/img/img-placeholder.jpg'">
                </a>
              </div>
              <div :class="{ 'col-md-11': !release.spotify_id, 'col-md-12': release.spotify_id }">
                <div>
                  <div v-if="release.spotify_url" class="mb-3">
                    <iframe style="border-radius:12px" :src="`https://open.spotify.com/embed/album/${release.spotify_id}?utm_source=generator`" width="100%" height="152" frameBorder="0" allowfullscreen="" allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture" loading="lazy"></iframe>
                  </div>
                  <img width="16" :src="`/static/img/countries/${release.user.country || 'default'}.png`"
                    class="mr-1 mb-2" :alt="getCountryName(release.user.country)"
                    :title="getCountryName(release.user.country)" />
                  <a :href="`https://indfy.me/${release.key}`" target="_blank" class="h3 mb-2 fw-bold">
                    {{ release.title }} <span v-if="release.pro" class="badge badge-primary ml-1">PRO</span>
                  </a>
                  <div class="small mb-1 pb-1">
                    <b>{{ $t('artist') }}:</b> <a :href="`https://indiefy.me/${release.artist.key}`" target="_blank">{{ release.artist.name }}</a>
                  </div>
                  <div class="small mb-1 pb-1">
                    <b>{{ $t('release_date') }}:</b> {{ moment(release.release_date).format('MMMM DD, YYYY') }}
                  </div>
                  <div class="small mb-1 pb-1">
                    <b>{{ $t('main_genre') }}:</b> {{ release.main_genre }} <i
                      class="fa fa-chevron-right text-muted small ml-1 mr-1"></i> {{ release.style }}
                  </div>
                  <div class="small mb-1 pb-1">
                    <b>{{ $t('platforms') }}:</b>
                    <div class="mt-1">
                      <a :href="release.spotify_url" class="mb-1 btn-sm btn btn-default btn-border mt-1 mr-2"
                        v-if="release.spotify_url" target="_blank">
                        <i class="fab fa-spotify mr-1"></i> Spotify
                      </a>
                      <a :href="release.youtube_url" class="mb-1 btn-sm mt-1 btn btn-default btn-border mr-2"
                        v-if="release.youtube_url" target="_blank">
                        <i class="fab fa-youtube mr-1"></i> YouTube
                      </a>
                      <a :href="release.apple_url" class="mb-1 btn-sm mt-1 btn btn-default btn-border mr-2"
                        v-if="release.apple_url" target="_blank">
                        <i class="fab fa-apple mr-1"></i> Apple Music
                      </a>
                      <a :href="release.deezer_url" class="mb-1 btn-sm mt-1 btn btn-default btn-border mr-2"
                        v-if="release.deezer_url" target="_blank">
                        <i class="fa fa-link mr-1"></i> Deezer
                      </a>
                      <a :href="release.amazon_url" class="mb-1 btn-sm mt-1 btn btn-default btn-border mr-2"
                        v-if="release.amazon_url" target="_blank">
                        <i class="fa fa-link mr-1"></i> Amazon
                      </a>
                      <a :href="release.itunes_url" class="mb-1 btn-sm mt-1 btn btn-default btn-border mr-2"
                        v-if="release.itunes_url" target="_blank">
                        <i class="fa fa-link mr-1"></i> iTunes
                      </a>
                    </div>
                  </div>
                </div>

                <div class="text-right">
                  <button type="button" class="btn" @click="toggleComments(release)">
                    <span v-if="release.showComments">
                      {{ $t('hide_comments') }} ({{ release.comments.length || 0 }}) <i
                        class="fa text-muted fa-chevron-up ml-1"></i>
                    </span>
                    <span v-if="!release.showComments">
                      {{ $t('show_comments') }} ({{ release.comments.length || 0 }}) <i
                        class="fa text-muted fa-chevron-down ml-1"></i>
                    </span>
                  </button>
                </div>

                <div v-show="release.showComments">
                  <hr>
                  <div class="card-list">
                    <p v-if="!release.comments.length">{{ $t('no_comments_yet') }}</p>
                    <div class="item-list blurred" v-if="(!user.subscription || (user.subscription && user.subscription.plan_name === 'indiefy_lite')) && tab === 'mine'">
                      <div class="avatar">
                        <img class="avatar-img rounded-circle" src="https://assets.indiefy.net/profile-images/1567806225726.jpg" alt="">
                      </div>
                      <div class="info-user ml-3">
                        <div class="username clearfix">Agnostic</div>
                        <div class="status">
                          <img width="16" :src="`/static/img/countries/MX.png`"
                            class="mr-1" /> Mexico
                        </div>
                        <div class="mt-2">
                          Your composition is too good, keep working!
                        </div>
                      </div>
                    </div>
                    <div class="item-list" v-for="(comment, commentIndex) in release.comments"
                      v-bind:key="`comment_${commentIndex}`" v-if="tab !== 'mine' || tab === 'mine' && user.subscription && user.subscription.plan_name !== 'indiefy_lite'">
                      <div class="avatar">
                        <a :href="`https://indiefy.me/${comment.author.key}`" class="pull-left" target="_blank">
                          <img :src="comment.author.cover_image_small || comment.author.cover_image || defaultImage" alt="..."
                            class="avatar-img rounded-circle" onerror="this.src = '/static/img/img-placeholder.jpg'">
                        </a>
                      </div>
                      <div class="info-user ml-3">
                        <div class="username clearfix">
                          <a :href="`https://indiefy.me/${comment.author.key}`" class="pull-left" target="_blank">
                            {{ comment.author.name }}
                          </a>
                          <div class="pull-right pr-2 text-muted small">
                            {{ moment(comment.createdAt).format('MMM DD, HH:mm') }}
                          </div>
                        </div>
                        <div class="status">
                          <img width="16" :src="`/static/img/countries/${comment.country || 'default'}.png`"
                            class="mr-1" /> {{ getCountryName(comment.country) }}
                        </div>
                        <div class="mt-2">
                          <i class="fa fa-quote-left text-muted mr-1"></i>
                          {{ $t(comment.strength) }} <span v-if="comment.areas_of_improvement">/ {{
                            $t(comment.areas_of_improvement) }}</span>
                          <i class="fa fa-quote-right ml-1 text-muted"></i>
                        </div>
                      </div>
                    </div>
                    <div class="item-list mb-0 pt-3" v-if="tab === 'mine' && (!user.subscription || user.subscription.plan_name === 'indiefy_lite')">
                      <router-link to="/upgrade?from=feedbacks">
                        {{ $t('upgrade_to_see_feedback') }}
                      </router-link>
                    </div>
                  </div>
                  <div class="text-right mt-3" v-if="release.user._id !== user._id">
                    <button type="button" :disabled="hasCommented(release)"
                      :class="{ 'btn-primary': !hasCommented(release) }" class="btn" @click="showCommentModal(release)">
                      {{ $t('add_comment') }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="text-center text-muted" v-if="loading">
          <i class="fa fa-spinner fa-spin"></i>
        </div>
      </div>
    </div>

    <div ref="modalComment" class="modal" tabindex="-1" role="dialog" data-backdrop="static">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title fw-bold">
              {{ $t('add_comment_for') }} <span v-if="selectedRelease">{{ selectedRelease.title }}</span>
            </h5>
          </div>
          <div class="modal-body">
            <div class="form-group">
              <label for="" class="fw-bold">{{ $t('commenting_as') }}</label>
              <select class="form-control" v-model="author">
                <option :value="artist._id" v-for="(artist, index) in artists" v-bind:key="`artist_${index}`">
                  {{ artist.name }}
                </option>
              </select>
            </div>
            <div class="form-group">
              <label for="" class="fw-bold">{{ $t('strengths') }}:</label>
              <select class="form-control" v-model="strength">
                <option value="feed_comment_wanna_collab">{{ $t('feed_comment_wanna_collab') }}</option>
                <option value="feed_comment_nice_job">{{ $t('feed_comment_nice_job') }}</option>
                <option value="feed_comment_good_composition">{{ $t('feed_comment_good_composition') }}</option>
                <option value="feed_comment_love_the_beat">{{ $t('feed_comment_love_the_beat') }}</option>
                <option value="feed_comment_great_melody">{{ $t('feed_comment_great_melody') }}</option>
                <option value="feed_comment_catchy_lyrics">{{ $t('feed_comment_catchy_lyrics') }}</option>
                <option value="feed_comment_amazing_vocals">{{ $t('feed_comment_amazing_vocals') }}</option>
                <option value="feed_comment_unique_style">{{ $t('feed_comment_unique_style') }}</option>
                <option value="feed_comment_inspiring_vibe">{{ $t('feed_comment_inspiring_vibe') }}</option>
                <option value="feed_comment_awesome_instrumentation">{{ $t('feed_comment_awesome_instrumentation') }}
                </option>
                <option value="feed_comment_professional_sound">{{ $t('feed_comment_professional_sound') }}</option>
                <option value="feed_comment_great_energy">{{ $t('feed_comment_great_energy') }}</option>
                <option value="feed_comment_well_structured">{{ $t('feed_comment_well_structured') }}</option>
                <option value="feed_comment_memorable_hook">{{ $t('feed_comment_memorable_hook') }}</option>
                <option value="feed_comment_smooth_transitions">{{ $t('feed_comment_smooth_transitions') }}</option>
                <option value="feed_comment_emotional_impact">{{ $t('feed_comment_emotional_impact') }}</option>
                <option value="feed_comment_excellent_emotional_build">{{ $t('feed_comment_excellent_emotional_build') }}</option>
                <option value="feed_comment_fantastic_vocal_control">{{ $t('feed_comment_fantastic_vocal_control') }}</option>
                <option value="feed_comment_unique_lyrical_storytelling">{{ $t('feed_comment_unique_lyrical_storytelling') }}</option>
                <option value="feed_comment_smooth_blend_of_genres">{{ $t('feed_comment_smooth_blend_of_genres') }}</option>
                <option value="feed_comment_powerful_chorus">{{ $t('feed_comment_powerful_chorus') }}</option>
                <option value="feed_comment_rich_and_deep_bassline">{{ $t('feed_comment_rich_and_deep_bassline') }}</option>
                <option value="feed_comment_creative_use_of_instruments">{{ $t('feed_comment_creative_use_of_instruments') }}</option>
                <option value="feed_comment_infectious_rhythm">{{ $t('feed_comment_infectious_rhythm') }}</option>
                <option value="feed_comment_well_balanced_mix">{{ $t('feed_comment_well_balanced_mix') }}</option>
                <option value="feed_comment_engaging_intro">{{ $t('feed_comment_engaging_intro') }}</option>
              </select>
            </div>
            <div class="form-group">
              <label for="" class="fw-bold">{{ $t('areas_for_improvement') }}:</label>
              <select class="form-control" v-model="areas_of_improvement">
                <option value="">{{ $t('feed_comment_nothing_to_say') }}</option>
                <option value="feed_comment_needs_more_energy">{{ $t('feed_comment_needs_more_energy') }}</option>
                <option value="feed_comment_not_catchy_enough">{{ $t('feed_comment_not_catchy_enough') }}</option>
                <option value="feed_comment_vocals_sound_off">{{ $t('feed_comment_vocals_sound_off') }}</option>
                <option value="feed_comment_repetitive_lyrics">{{ $t('feed_comment_repetitive_lyrics') }}</option>
                <option value="feed_comment_instruments_overpower_vocals">{{
                  $t('feed_comment_instruments_overpower_vocals') }}</option>
                <option value="feed_comment_mixing_could_improve">{{ $t('feed_comment_mixing_could_improve') }}</option>
                <option value="feed_comment_lacks_originality">{{ $t('feed_comment_lacks_originality') }}</option>
                <option value="feed_comment_too_long_for_genre">{{ $t('feed_comment_too_long_for_genre') }}</option>
                <option value="feed_comment_not_engaging_enough">{{ $t('feed_comment_not_engaging_enough') }}</option>
                <option value="feed_comment_inconsistent_rhythm">{{ $t('feed_comment_inconsistent_rhythm') }}</option>
                <option value="feed_comment_needs_more_variety">{{ $t('feed_comment_needs_more_variety') }}</option>
                <option value="feed_comment_lyrics_could_be_stronger">{{ $t('feed_comment_lyrics_could_be_stronger') }}
                </option>
                <option value="feed_comment_tempo_feels_off">{{ $t('feed_comment_tempo_feels_off') }}</option>
                <option value="feed_comment_more_clarity_in_mixing">{{ $t('feed_comment_more_clarity_in_mixing') }}
                </option>
                <option value="feed_comment_needs_better_flow">{{ $t('feed_comment_needs_better_flow') }}</option>
                <option value="feed_comment_chorus_needs_more_impact">{{ $t('feed_comment_chorus_needs_more_impact') }}</option>
                <option value="feed_comment_too_many_effects_on_vocals">{{ $t('feed_comment_too_many_effects_on_vocals') }}</option>
                <option value="feed_comment_bassline_overpowers_other_elements">{{ $t('feed_comment_bassline_overpowers_other_elements') }}</option>
                <option value="feed_comment_melody_lacks_variety">{{ $t('feed_comment_melody_lacks_variety') }}</option>
                <option value="feed_comment_song_structure_needs_clarity">{{ $t('feed_comment_song_structure_needs_clarity') }}</option>
                <option value="feed_comment_more_focus_on_lyric_clarity">{{ $t('feed_comment_more_focus_on_lyric_clarity') }}</option>
                <option value="feed_comment_needs_stronger_bridge">{{ $t('feed_comment_needs_stronger_bridge') }}</option>
                <option value="feed_comment_adjust_tempo_for_more_flow">{{ $t('feed_comment_adjust_tempo_for_more_flow') }}</option>
                <option value="feed_comment_lacks_cohesive_theme">{{ $t('feed_comment_lacks_cohesive_theme') }}</option>
                <option value="feed_comment_more_dynamics_needed">{{ $t('feed_comment_more_dynamics_needed') }}</option>
              </select>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn" data-dismiss="modal">
              {{ $t('cancel') }}
            </button>
            <button type="button" class="btn btn-primary" @click="addComment()">
              {{ $t('add') }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <div ref="submitReleaseModal" class="modal" tabindex="-1" role="dialog" data-backdrop="static"
      data-keyboard="false">
      <div class="modal-dialog " role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title text-dark">
              {{ $t('feature_1_week') }}
            </h4>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="form-group">
              <div class="alert alert-warning">
                {{ $t('earn_credits_by') }}
              </div>
            </div>
            <div class="form-group">
              <label for="">{{ $t('credit_cost') }}</label>
              <span class="form-control">{{ creditCost }}</span>
            </div>
            <div class="form-group">
              <label for="">{{ $t('your_credits') }}</label>
              <span class="form-control">{{ user.credits }}</span>
            </div>
            <div class="form-group">
              <div class="progress" >
                <div class="progress-bar progress-bar-success" :style="`width: ${percentage || 1}%;`"></div>
              </div>
            </div>
            <div class="form-group">
              <label for="">{{ $t('release') }}</label>
              <select class="form-control" v-model="featuredRelease">
                <option :value="release._id" v-for="(release, index) in myReleases" v-bind:key="`myrelease_${index}`">
                  {{ release.title }}
                </option>
              </select>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-light" data-dismiss="modal">{{ $t('cancel') }}</button>
            <button type="button" :disabled="!featuredRelease" class="btn btn-primary" @click="submitRelease()"
              v-if="user.subscription && user.subscription.plan_name !== 'indiefy_lite'">
              {{ $t('send') }}
            </button>
            <router-link tag="button" class="btn btn-gradient" to="/upgrade?from=feed" v-if="!user.subscription || (user.subscription && user.subscription.plan_name === 'indiefy_lite')">
              {{ $t('upgrade_to_pro') }}
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import _ from 'underscore'
import Public from '../services/public'
import Artists from '../services/artists'
import Distributions from '../services/distributions'
import moment from 'moment'
import countries from '../data/countries'
import Smartlinks from '../services/smartlinks'

export default {
  name: 'Feed',
  data: function () {
    return {
      defaultImage: '/static/img/img-placeholder.jpg',
      progress: 1,
      tab: 'all',
      creditCost: 100,
      page: 0,
      totalItems: 0,
      loading: false,
      throttleScroll: null,
      moment,
      author: '',
      releases: [],
      featuredReleases: [],
      featuredRelease: '',
      myReleases: [],
      artists: [],
      selectedRelease: {},
      strength: '',
      areas_of_improvement: ''
    }
  },
  methods: {
    showCreditsInfo: function () {
      this.$notify({ message: this.$t('earn_credits_by') }, 'info', 'fa-coins')
    },
    submitRelease: function () {
      if (!this.featuredRelease) {
        return this.$notify({ message: this.$t('select_a_release_title') }, 'warning', 'fa-exclamation-triangle')
      }

      if (!this.user.credits || this.user.credits < this.creditCost) {
        return this.$notify({ message: this.$t('no_enough_credits') }, 'warning', 'fa-exclamation-triangle')
      }

      window.$(this.$refs.submitReleaseModal).modal('hide')

      Distributions.featureRelease(this.featuredRelease).then(() => {
        this.user.credits = this.user.credits - this.creditCost
        this.$notify({ message: this.$t('request_sent') }, 'success', 'fa-check')
      })
    },
    getMyReleases: function () {
      Distributions.getAll({ status: [3] }).then((response) => {
        this.myReleases = response.data
      })
    },
    featureModal: function () {
      window.$(this.$refs.submitReleaseModal).modal('show')
    },
    initFeaturedCarousel: function () {
      setTimeout(() => {
        window.$('.carousel-slider-featured-releases').owlCarousel({
          autoPlay: 5000,
          navigation: false,
          slideSpeed: 500,
          pagination: false,
          autoplayHoverPause: true,
          paginationSpeed: 1000,
          singleItem: true,
          items: 1,
          autoHeight: true,
          addClassActive: true,
          goToFirst: true,
          goToFirstSpeed: 200
        })
      }, 50)
    },
    handleScroll: function (event) {
      if (this.loading) return

      if (window.$(window).scrollTop() + window.$(window).height() >= (window.$(document).height() - 150)) {
        this.page += 1

        if (this.releases.length < this.totalItems) {
          this.getReleases()
        }
      }
    },
    hasCommented: function (release) {
      let hasCommented = false

      _.each(release.comments, comment => {
        if (comment.author.user === this.user._id) {
          hasCommented = true
        }
      })

      return hasCommented
    },
    getCountryName: function (userCountry) {
      let country = _.find(countries, item => item.code === userCountry)

      if (country) {
        return country.name
      }

      return 'N/A'
    },
    getArtits: function () {
      Artists.getAll({ limit: 1, page: this.page }).then(response => {
        this.artists = response.data

        if (this.artists.length) {
          this.author = this.artists[0]._id
        }
      })
    },
    toggleComments: function (release) {
      release.showComments = !release.showComments
      this.$forceUpdate()
    },
    getFeaturedReleases: function () {
      Public.getFeaturedReleases().then(response => {
        let releases = response.data

        _.each(releases, (item, index) => {
          item.comments = []

          if (item.spotify_url) {
            item.spotify_id = item.spotify_url.split('/').pop()

            if (item.spotify_id.match(/\?/)) {
              item.spotify_id = item.spotify_id.split('?')[0]
            }
          }

          setTimeout(() => {
            Distributions.getComments(item._id).then(response => {
              item.comments = response.data || []
            })
          }, index * 300)
        })

        this.featuredReleases = releases
        this.initFeaturedCarousel()
      })
    },
    getReleases: function () {
      let releasesFilter = { limit: 10, page: this.page, status: 3 }
      this.loading = true

      if (this.$route.query.user) {
        this.page = 0
        this.releases = []
        releasesFilter.user = this.$route.query.user
        releasesFilter.limit = 100
        releasesFilter.page = 0
      }

      Public.getLatestReleases(releasesFilter).then(response => {
        let releases = response.data.items
        this.totalItems = response.data.total

        _.each(releases, (item, index) => {
          item.comments = []

          if (item.spotify_url) {
            item.spotify_id = item.spotify_url.split('/').pop()

            if (item.spotify_id.match(/\?/)) {
              item.spotify_id = item.spotify_id.split('?')[0]
            }
          } else {
            Smartlinks.getSmartlinkByKey(item.key)
          }

          setTimeout(() => {
            Distributions.getComments(item._id).then(response => {
              item.comments = response.data || []
            })
          }, index * 300)
        })

        if (!this.releases.length) {
          this.releases = releases
        } else {
          this.releases = this.releases.concat(releases)
        }

        this.loading = false
      })
    },
    checkTabs: function () {
      if (this.$route.query.user) {
        this.tab = 'mine'
      } else {
        this.tab = 'all'
      }
    },
    addComment: function () {
      if (!this.strength) {
        return this.$notify({ message: this.$t('good_feedback_needed') }, 'warning', 'fa-exclamation-triangle')
      }

      Distributions.postComment(this.selectedRelease._id, this.strength, this.areas_of_improvement, this.author).then((response) => {
        if (!this.user.credits) {
          this.user.credits = 0
        }

        this.user.credits = this.user.credits + 10
        this.strength = ''
        this.areas_of_improvement = ''

        Distributions.getComments(this.selectedRelease._id).then(response => {
          this.selectedRelease.comments = response.data || []
        })
      })

      window.$(this.$refs.modalComment).modal('hide')
    },
    showCommentModal: function (release) {
      if (!this.artists.length) {
        return this.$notify({ message: this.$t('artist_needed') }, 'warning', 'fa-exclamation-triangle')
      }

      this.selectedRelease = release
      window.$(this.$refs.modalComment).modal('show')
    }
  },
  computed: {
    percentage: function () {
      let credits = this.user.credits || 0
      let totalCredits = this.creditCost
      return (credits / totalCredits) * 100
    }
  },
  watch: {
    $route: function () {
      this.checkTabs()
      this.getReleases()
    }
  },
  mounted: function () {
    setTimeout(() => {
      this.throttleScroll = _.throttle(this.handleScroll, 1000)
      window.addEventListener('scroll', this.throttleScroll)

      window.$('html, body').animate({
        scrollTop: 0
      }, 500)
    }, 2000)
  },
  beforeDestroy: function () {
    window.removeEventListener('scroll', this.throttleScroll)
  },
  created: function () {
    this.user = this.$user
    this.checkTabs()
    this.getReleases()
    this.getFeaturedReleases()
    this.getArtits()
    this.getMyReleases()
  },
  components: {
  }
}
</script>
<style lang="scss" scoped>
.card-list {
  max-height: 200px;
  overflow-y: auto;
}

.item-list {
  margin-bottom: 10px;
}

.featured-star {
  position: absolute;
  top: 5px;
  right: 5px;
  z-index: 1000;
}

.blurred {
  -webkit-filter: blur(3px);
  -moz-filter: blur(3px);
  -o-filter: blur(3px);
  -ms-filter: blur(3px);
  filter: blur(3px);
  background-color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/Feed.vue